// Process-wide per-tab exec table singleton (EPIC #157, phase P5).
//
// The "one stream per run per tab" guard (decomposition-plan §7 #3) was previously
// a per-App lazy `useRef` init in App.jsx (`createExecTable()`). Commands run outside
// React and can't reach a component ref, so the table becomes a module-level singleton
// here — the disposition §7 #3 calls for. `App.jsx` points its `execByRunIdRef.current`
// at THIS instance, so every consumer still in a hook/adapter (branch / reforecast /
// dispatchIntent) and every extracted command (submitForecast, …) share one table with
// identical claim/release semantics. Behavior is unchanged; only the ownership moves.
import { createExecTable } from "../lib/forecast/exec.js";

/** The shared per-tab execution table (AbortController / SSE-reader handles keyed by runId). */
export const execTable = createExecTable();
